import { apiInterfaceForJson } from '../common/apiManager';

export const fetchAllFamilies = () => {
    return apiInterfaceForJson('/family/v1/', 'GET').catch((error) => {
        console.error('Error fetching families:', error);
        return { data: [] };
    });
};

export const fetchFamilyById = (familyId) => {
    return apiInterfaceForJson('/family/v1/' + familyId, 'GET').catch((error) => {
        console.error('Error fetching family:', error);
        return { data: null };
    });
};

export const searchFamilies = (data) => {
    return apiInterfaceForJson('/family/v1/search', 'POST', data).catch((error) => {
        console.error('Error searching families:', error);
        return { data: [] };
    });
};

export const createFamily = (data) => {
    return apiInterfaceForJson('/family/v1/', 'POST', data);
};

export const updateFamily = (data) => {
    return apiInterfaceForJson('/family/v1/', 'PUT', data);
};

export const deleteFamily = (familyId) => {
    return apiInterfaceForJson('/family/v1/' + familyId, 'DELETE');
};

export const fetchFamilyMembers = (familyId) => {
    return apiInterfaceForJson('/family/v1/' + familyId + '/members', 'GET').catch((error) => {
        console.error('Error fetching family members:', error);
        return { data: [] };
    });
};

export const fetchFamilyOrders = (familyId, filters) => {
    return apiInterfaceForJson('/family/v1/' + familyId + '/orders', 'POST', filters).catch((error) => {
        console.error('Error fetching family orders:', error);
        return { data: [] };
    });
};
